import React from 'react';
import LanguageHeader from '../../../container/LanguageHeader';
import Footer from '../../Footer';
import styles from './DefaultLayout.module.scss';

const DefaultLayout: React.FC<WithChildren> = ({ children }: WithChildren) => {
  return (
    <div className={styles.defaultLayout}>
      <header>
        <LanguageHeader brandName={''} />
      </header>
      <div className={styles.content}>{children}</div>
      <Footer />
    </div>
  );
};

export default DefaultLayout;
